import classNames from 'classnames';

import Modal from 'lib/components/modal/Modal';
import Table from 'lib/components/table/Table';
import SearchInput from 'lib/components/search-input/SearchInput';
import Pagination from 'lib/components/pagination/Pagination';
import ImageFallback from 'lib/components/image-fallback/ImageFallback';
import StatusPill, {
  STATUS_PILL_VARIANT,
} from 'lib/components/status-pill/StatusPill';

import './AssetsModal.scss';

const assetsTableColumns = [
  {
    title: 'ID / External ID',
    sortId: 'id',
    className: 'id-cell',
    render: (record) => (
      <span>
        {record.id} {!!record?.externalId && `/ ${record.externalId}`}
      </span>
    ),
  },
  {
    title: 'Image / Name',
    className: 'name-cell',
    sortId: 'name',
    render: (record) => (
      <div className='name'>
        {record.images && (
          <ImageFallback src={record.images[0]?.url} fallback={null} />
        )}
        <span className='title'>{record.name}</span>
      </div>
    ),
  },
  {
    title: 'Type',
    className: 'type-cell',
    render: (record) => (
      <StatusPill variant={STATUS_PILL_VARIANT.NOTIFY}>
        {record.type?.name}
      </StatusPill>
    ),
  },
];

const AssetsModal = ({
  isOpen,
  search,
  onSearchChange,
  data = [],
  onRowClick,
  onSubmit,
  sortOrder,
  setSortBy,
  sortBy,
  page,
  pageSize,
  setPage,
  count,
  className,
  ...props
}) => {
  const hasPagination = setPage && pageSize && page && count > 0;
  return (
    <Modal
      title='Assign asset'
      header={
        <div className='search-container'>
          <SearchInput
            value={search}
            onChange={onSearchChange}
            placeholder='Search'
            data-testid='AssetsModal.search'
          />
        </div>
      }
      actions={
        hasPagination && (
          <Pagination
            pageSize={pageSize}
            setPage={setPage}
            page={page}
            count={count}
            threshold={3}
          />
        )
      }
      className={classNames('assets-modal', className)}
      isOpen={isOpen}
      ariaHideApp={false}
      {...props}
    >
      <Table
        data={data}
        columns={assetsTableColumns}
        onRowClick={onRowClick}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        sortBy={sortBy}
      />
    </Modal>
  );
};

export default AssetsModal;
